import { render, staticRenderFns } from "./EntryForm.vue?vue&type=template&id=c631e64a&scoped=true"
import script from "./EntryForm.vue?vue&type=script&lang=js"
export * from "./EntryForm.vue?vue&type=script&lang=js"
import style0 from "./EntryForm.vue?vue&type=style&index=0&id=c631e64a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c631e64a",
  null
  
)

export default component.exports